/**
 * Shared keystroke/commit rules for the min/max axis-range fields.
 *
 * The fields accept only strings that could become a valid number — digits,
 * one leading minus, one decimal point — rejected at keystroke level (which
 * also covers paste, since filtering happens on the resulting value). Commit
 * still re-validates: partial states like "-", ".", or "-." pass the
 * keystroke filter but do not parse, and must not commit.
 */

const PARTIAL_NUMBER_RE = /^-?\d*\.?\d*$/

/** True when `value` is a permissible in-progress state of typing a number. */
export const isPartialNumericInput = (value: string): boolean =>
  PARTIAL_NUMBER_RE.test(value)

/**
 * Parses a committed field value. Empty string means "cleared" (revert to
 * auto) and maps to undefined-with-success; a non-numeric or non-finite
 * leftover is rejected.
 */
export const parseCommittedNumber = (
  value: string
): { ok: true; value: number | undefined } | { ok: false } => {
  const trimmed = value.trim()
  if (trimmed === '') {
    return { ok: true, value: undefined }
  }
  const parsed = parseFloat(trimmed)
  if (Number.isFinite(parsed)) {
    return { ok: true, value: parsed }
  }
  return { ok: false }
}
